import { gql } from "@apollo/client"

export const dashboardUserTeamsList = gql`
  query DashboardUserTeamsList($input: DashboardUserTeamsListInput) {
    dashboardUserTeamsList(input: $input) {
      items {
        team {
          id
          isPrimary
          stakeholderType
          userCount
          dashboardMinMembers
          document {
            lang
            title
            logo
          }
        }
      }
      nextToken
    }
  }
`

export const dashboardTeamGroupList = gql`
  query DashboardTeamGroupList($input: DashboardTeamGroupListInput) {
    dashboardTeamGroupList(input: $input) {
      items {
        groupId
        name
      }
    }
  }
`

export const dashboardTeamCountriesList = gql`
  query DashboardTeamCountriesList($input: DashboardTeamCountriesListInput) {
    dashboardTeamCountriesList(input: $input) {
      items {
        country
      }
      nextToken
    }
  }
`

export const dashboardTotalUsersGet = gql`
  query DashboardTotalUsersGet($input: DashboardTotalUsersGetInput) {
    dashboardTotalUsersGet(input: $input) {
      users
      activeUsersPercentage
    }
  }
`

export const dashboardAverageUserGet = gql`
  query DashboardAverageUserGet($input: DashboardAverageUserGetInput) {
    dashboardAverageUserGet(input: $input) {
      country
      percentage
      users
    }
  }
`

export const dashboardMostActiveUserGet = gql`
  query DashboardMostActiveUserGet($input: DashboardMostActiveUserGetInput) {
    dashboardMostActiveUserGet(input: $input) {
      sub
      activityHour
      avgActionsComparisonPercentage
      avgEpisodesComparisonPercentage
      country
      sameActiveHourPercentage
      userActions
      userEpisodes
      user {
        first_name
        last_name
        country
        uid
        nickname
        profileImage
        sub
      }
    }
  }
`

export const dashboardChallengeLeaderboardGet = gql`
  query DashboardChallengeLeaderboardGet(
    $input: DashboardChallengeLeaderboardGetInput
  ) {
    dashboardChallengeLeaderboardGet(input: $input) {
      items {
        previousWeekUserPosition
        sub
        userPoints
        userPointsDeltaPercentage
        userPosition
        userPositionDelta
        user {
          first_name
          last_name
          country
          uid
          nickname
          profileImage
          decodedSub
          sub
        }
      }
      nextToken
    }
  }
`

export const dashboardActivityOverviewList = gql`
  query DashboardActivityOverviewList(
    $input: DashboardActivityOverviewListInput
  ) {
    dashboardActivityOverviewList(input: $input) {
      items {
        activityAmount
        activityDate
        activityType
        avgActivitiesDeltaPercentage
        avgActivityAmount
      }
      nextToken
    }
  }
`

export const dashboardActivitiesByCategoryList = gql`
  query DashboardActivitiesByCategoryList(
    $input: DashboardActivitiesByCategoryListInput
  ) {
    dashboardActivitiesByCategoryList(input: $input) {
      items {
        activityAmount
        activityCategory
        activityType
      }
      nextToken
    }
  }
`

export const dashboardSavingsGet = gql`
  query DashboardSavingsGet($input: DashboardSavingsGetInput) {
    dashboardSavingsGet(input: $input) {
      bathTubSaving
      co2Saving
      dishWasherSaving
      energySaving
      phoneChargeSaving
      waterSaving
    }
  }
`

export const dashboardFootprintOverviewGet = gql`
  query DashboardFootprintOverviewGet(
    $input: DashboardFootprintOverviewGetInput
  ) {
    dashboardFootprintOverviewGet(input: $input) {
      avgEmissionAmount
      footprintUsers
      maxEmissionAmount
      minEmissionAmount
      parisAgreementEmissionAmount
      parisAgreementEmissionDeltaPercentage
      totalUsers
      worldEmissionAmount
      worldEmissionDeltaPercentage
    }
  }
`

export const dashboardFootprintBreakdownGet = gql`
  query DashboardFootprintBreakdownGet(
    $input: DashboardFootprintBreakdownGetInput
  ) {
    dashboardFootprintBreakdownGet(input: $input) {
      items {
        category
        categoryEmissionAmountAvg
        categoryEmissionPercentage
        totalEmissionAmount
        totalEmissionAmountAvg
        totalEmissionAsLaptopCharges
        totalEmissionAsLondonNYFlights
        totalEmissionAsTrees
      }
    }
  }
`

export const dashboardFootprintBreakdownByGroupGet = gql`
  query DashboardFootprintBreakdownByGroupGet(
    $input: DashboardFootprintBreakdownByGroupGetInput
  ) {
    dashboardFootprintBreakdownByGroupGet(input: $input) {
      items {
        category
        categoryEmissionAmountAvg
        categoryEmissionPercentage
        groupId
      }
      nextToken
    }
  }
`

export const dashboardTopSdgsList = gql`
  query DashboardTopSdgsList($input: DashboardTopSdgsListInput) {
    dashboardTopSdgsList(input: $input) {
      items {
        activityAmount
        activitySdg
        position
        type
      }
      nextToken
    }
  }
`

export const dashboardTopCategoriesList = gql`
  query DashboardTopCategoriesList($input: DashboardTopCategoriesListInput) {
    dashboardTopCategoriesList(input: $input) {
      items {
        activityAmount
        activityCategory
        position
        type
      }
      nextToken
    }
  }
`

export const dashboardTopContentList = gql`
  query DashboardTopContentList($input: DashboardTopContentListInput) {
    dashboardTopContentList(input: $input) {
      items {
        activityAmount
        activityCategory
        activityName
        position
        type
        action {
          id
          image
          document {
            title
          }
          category {
            id
            code
            lang
            name
            backColor
            backTagColor
            foreColor
          }
        }
      }
      nextToken
    }
  }
`

export const dashboardCompletedEpisodesList = gql`
  query DashboardCompletedEpisodesList(
    $input: DashboardCompletedEpisodesListInput
  ) {
    dashboardCompletedEpisodesList(input: $input) {
      items {
        activityPartitionType
        partitionAmount
        partitionType
        totalAmount
      }
      nextToken
    }
  }
`

export const dashboardTotalEducationHoursGet = gql`
  query DashboardTotalEducationHoursGet(
    $input: DashboardTotalEducationHoursGetInput
  ) {
    dashboardTotalEducationHoursGet(input: $input) {
      avgEducationHoursPerUser
      totalEducationHours
    }
  }
`

export const dashboardFootprintCategoryBreakdownGet = gql`
  query DashboardFootprintCategoryBreakdownGet(
    $input: DashboardFootprintCategoryBreakdownGetInput
  ) {
    dashboardFootprintCategoryBreakdownGet(input: $input) {
      items {
        category
        sector
        sectorEmissionAmountAvg
        sectorEmissionPercentage
        categoryEmissionAmountAvg
      }
    }
  }
`

export const dashboardTotalEducationHoursUsersGet = gql`
  query DashboardTotalEducationHoursUsersGet(
    $input: DashboardTotalEducationHoursUsersGetInput
  ) {
    dashboardTotalEducationHoursUsersGet(input: $input) {
      items {
        totalEducationHours
        user {
          first_name
          last_name
          country
          uid
          nickname
          profileImage
          sub
        }
      }
      nextToken
    }
  }
`

export const dashboardEpisodePerformanceList = gql`
  query DashboardEpisodePerformanceList(
    $input: DashboardEpisodePerformanceListInput
  ) {
    dashboardEpisodePerformanceList(input: $input) {
      items {
        position
        episodeCompleted
        episodeCorrectlyCompleted
        episode {
          id
          image
          translation {
            title
          }
          category {
            id
            code
            lang
            name
            backColor
            backTagColor
            foreColor
          }
        }
      }
      nextToken
    }
  }
`

export const dashboardDailyChallengeOverviewGet = gql`
  query DashboardDailyChallengeOverviewGet(
    $input: DashboardDailyChallengeOverviewGetInput
  ) {
    dashboardDailyChallengeOverviewGet(input: $input) {
      items {
        activityDate
        activityAmount
      }
      nextToken
    }
  }
`

export const challengesPastList = gql`
  query ChallengesPastList($input: ChallengesPastListInput) {
    challengesPastList(input: $input) {
      id
      name
      userCount
      currentAmount
      targetAmount
      startsAt
      endsAt
      document {
        lang
        title
        image
      }
      metric {
        name
        unit
      }
    }
  }
`

export const dashboardFootprintMonthlyUserGet = gql`
  query DashboardFootprintMonthlyUserGet(
    $input: DashboardFootprintMonthlyUserGetInput
  ) {
    dashboardFootprintMonthlyUserGet(input: $input) {
      items {
        activityAmount
        activityDate
      }
    }
  }
`

export const dashboardActivityList = gql`
  query DashboardActivityListV2($input: DashboardActivityListInputV2) {
    dashboardActivityListV2(input: $input) {
      items {
        activityDate
        activityAmount
      }
    }
  }
`

export const dashboardMissionList = gql`
  query DashboardMissionListV2($input: DashboardMissionListInputV2) {
    dashboardMissionListV2(input: $input) {
      items {
        missionDate
        missionAmount
      }
    }
  }
`

export const dashboardPaymentList = gql`
  query DashboardPaymentListV2($input: DashboardPaymentListInputV2) {
    dashboardPaymentListV2(input: $input) {
      items {
        paymentDate
        paymentAmount
      }
    }
  }
`

export const dashboardTagGet = gql`
  query DashboardTagGet($input: DashboardTagGetInput) {
    dashboardTagGet(input: $input) {
      items {
        id
        name
        type
        code
        backColor
        backTagColor
        foreColor
        image
      }
    }
  }
`

export const dashboardChallengeList = gql`
  query DashboardChallengeList($input: DashboardChallengeListInput) {
    dashboardChallengeList(input: $input) {
      items {
        users
        activeUsers
        challenge {
          id
          name
          currentAmount
          targetAmount
          startsAt
          endsAt
          document {
            lang
            title
            image
          }
          metric {
            name
            unit
          }
        }
      }
    }
  }
`

export const dashboardChallengeGroupLeaderboardGet = gql`
  query DashboardChallengeGroupLeaderboardGet(
    $input: DashboardChallengeGroupLeaderboardGetInput
  ) {
    dashboardChallengeGroupLeaderboardGet(input: $input) {
      items {
        groupId
        groupPoints
        groupPosition
        leaderboardGroupType
      }
      nextToken
    }
  }
`

export const dashboardUserGet = gql`
  query DashboardUserGet($input: DashboardUserGetInput) {
    dashboardUserGet(input: $input) {
      items {
        userActiveAmount
        userAmount
        userDate
        userNew
      }
    }
  }
`

export const dashboardTotalNewsGet = gql`
  query DashboardTotalNewsGet($input: DashboardTotalNewsGetInput) {
    dashboardTotalNewsGet(input: $input) {
      totalNews
    }
  }
`

export const dashboardTotalSurveyGet = gql`
  query DashboardTotalSurveyGet($input: DashboardTotalSurveyGetInput) {
    dashboardTotalSurveyGet(input: $input) {
      totalSurvey
    }
  }
`

export const dashboardEducationHoursGet = gql`
  query DashboardEducationHoursGet($input: DashboardEducationHoursGetInput) {
    dashboardEducationHoursGet(input: $input) {
      items {
        eduAmount
        eduAmountAvg
        eduDate
      }
    }
  }
`

export const dashboardTotalQuizGet = gql`
  query DashboardTotalQuizGet($input: DashboardTotalQuizGetInput) {
    dashboardTotalQuizGet(input: $input) {
      totalQuiz
      totalQuizSuccess
    }
  }
`

export const dashboardTotalStoryGet = gql`
  query DashboardTotalStoryGet($input: DashboardTotalStoryGetInput) {
    dashboardTotalStoryGet(input: $input) {
      totalStory
      totalStorySuccess
    }
  }
`

export const episodesList = gql`
  query EpisodesList($input: ListEpisodesInput) {
    episodesList(input: $input) {
      items {
        id
        image
        translation {
          title
        }
        sdgs {
          primary
          sdg {
            id
            code
            lang
            name
            image
          }
        }
        topics {
          primary
          topic {
            id
            code
            lang
            name
          }
        }
      }
      nextToken
    }
  }
`

export const episode = gql`
  query Episode($episodeId: ID!, $lang: Lang) {
    episode(id: $episodeId, lang: $lang) {
      id
      lang
      image
      translation {
        id
        title
        slides {
          ... on EmbedSlide {
            id
            slideType
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            textColor
            embedSlideText: text
            embedSlideCaption: caption
            embedSlideCaptionTitle: captionTitle
            embedUrl
          }
          ... on FullImageSlide {
            id
            slideType
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            textColor
            fullImageSlideImage: image {
              type
              url
              description
            }
            caption
            captionTitle
          }
          ... on FullTextSlide {
            id
            slideType
            textColor
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            fullTextSlideText: text
          }
          ... on PortraitSlide {
            id
            slideType
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            textColor
            portraitSlideImage: image {
              type
              url
              description
            }
            portraitSlideText: text
          }
          ... on QuoteSlide {
            id
            slideType
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            textColor
            quoteSlideImage: image {
              type
              url
              description
            }
            author
            authorTitle
            text
          }
          ... on TextImageSlide {
            id
            slideType
            textColor
            background
            decor
            box {
              boxShape
              boxBackColor
            }
            textImageSlideImage: image {
              type
              url
              description
            }
            text
          }
          ... on TitleSlide {
            id
            slideType
            textColor
            background
            decor
            tagBox {
              tagBoxBackColor
              tagBoxTextColor
              tagBoxText
            }
            box {
              boxShape
              boxBackColor
            }
            title
            description
            image {
              type
              url
              description
            }
          }
        }
        quiz {
          id
          question
          opt1 {
            text
          }
          opt2 {
            text
          }
          opt3 {
            text
          }
          opt4 {
            text
          }
          correctAnswer
          box {
            boxBackColor
          }
        }
      }
    }
  }
`

export const topicsList = gql`
  query TopicsList($input: ListTopicsInput) {
    topicsList(input: $input) {
      items {
        id
        code
        lang
        name
      }
    }
  }
`

export const userGet = gql`
  query UserGet {
    userGet {
      sub
      email
    }
  }
`

export const dashboardMobilityTransportList = gql`
  query DashboardMobilityTransportList($input: DashboardMobilityListInput) {
    dashboardMobilityTransportList(input: $input) {
      items {
        type
        sustainability
        trips
        distanceKm
        durationMinutes
        co2AvoidedKg
        co2Kg
      }
      nextToken
    }
  }
`

export const dashboardMobilityWeeklyList = gql`
  query DashboardMobilityWeeklyList($input: DashboardMobilityListInput) {
    dashboardMobilityWeeklyList(input: $input) {
      items {
        weekStart
        co2AvoidedKg
        cumulativeCo2AvoidedKg
      }
      nextToken
    }
  }
`

export const dashboardMobilityCountriesList = gql`
  query DashboardMobilityCountriesList($input: DashboardMobilityListInput) {
    dashboardMobilityCountriesList(input: $input) {
      items {
        country
        users
        totalUsers
      }
      nextToken
    }
  }
`

export const dashboardMobilitySustainableSummaryGet = gql`
  query DashboardMobilitySustainableSummaryGet(
    $input: DashboardMobilitySustainableSummaryGetInput
  ) {
    dashboardMobilitySustainableSummaryGet(input: $input) {
      users
      totalCo2AvoidedKg
      totalDistanceKm
      totalDurationMinutes
      averageCo2AvoidedKgPerUser
      averageDistanceKmPerUser
      averageDurationMinutesPerUser
    }
  }
`

export const dashboardCommuteEmissionsMonthlyList = gql`
  query DashboardCommuteEmissionsMonthlyList(
    $input: DashboardCommuteEmissionsMonthlyListInput
  ) {
    dashboardCommuteEmissionsMonthlyList(input: $input) {
      items {
        month
        co2Kg
        carbonicIntensity
        trips
        co2FromMeanKg
        users
        teamUsers
      }
      nextToken
    }
  }
`

export const dashboardCommuteModesMonthlyList = gql`
  query DashboardCommuteModesMonthlyList(
    $input: DashboardCommuteEmissionsMonthlyListInput
  ) {
    dashboardCommuteModesMonthlyList(input: $input) {
      items {
        month
        mode
        sustainability
        distanceKm
        entries
        usedEntries
      }
      nextToken
    }
  }
`
